
import { z } from "zod";
import { LoanPurpose } from "@/services/api/types";

// Form validation schema
export const formSchema = z.object({
  firstName: z.string().min(1, { message: "Etunimi on pakollinen" }),
  lastName: z.string().min(1, { message: "Sukunimi on pakollinen" }),
  email: z.string().email({ message: "Virheellinen sähköposti" }),
  phoneNumber: z.string().min(1, { message: "Puhelinnumero on pakollinen" })
    .refine((val) => /^\+?[0-9\s-()]{6,20}$/.test(val), { message: "Virheellinen puhelinnumero" }),
  loanPurpose: z.nativeEnum(LoanPurpose),
  loanAmount: z.number().min(1000),
  loanTerm: z.number().min(1).max(15),
  termsAccepted: z.boolean().refine((val) => val === true, { 
    message: "Sinun täytyy hyväksyä käyttöehdot" 
  }),
  marketingConsent: z.boolean().default(false),
  // Add these fields but make them optional, removing employmentStatus
  loanType: z.string().optional(),
  education: z.string().optional(),
  natureOfWork: z.string().optional(),
  startOfEmployment: z.string().optional(),
  hasCoApplicant: z.boolean().optional(),
});

export type FormValues = z.infer<typeof formSchema>;
